"use client";

import { useEffect, useState } from "react";
import { api } from "../../maps/data.js";
import { Check } from "lucide-react"; // Import Lucide's Check Icon

const TempCart = ({ siteId }) => {
  const [carts, setCarts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Function to fetch cart data
  const fetchCarts = async () => {
    console.log("Fetching carts...");
    try {
      const response = await api({
        type: "getActiveCarts",
        data: {
          siteId: siteId,
        },
        disableBI: true,
      });
      setCarts(response);
      setLoading(false);
    } catch (err) {
      setError("Failed to load carts");
      setLoading(false);
    }
  };

  // Fetch cart initially and refresh every 5 seconds
  useEffect(() => {
    fetchCarts(); // Initial fetch

    const interval = setInterval(() => {
      fetchCarts();
    }, 5000); // Refresh every 5 seconds

    return () => clearInterval(interval); // Cleanup on unmount
  }, [siteId]); // Added siteId as a dependency

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div className="sp ace-y-2 p -1 ">
      {carts &&
        carts.map((cart, index) => (
          <div
            key={index}
            className="rounded-lg shadow-lg p-2 border-2 border-white
"
            style={{
              // background:
              display: cart.products.length === 0 ? "none" : "block",
            }}
          >
            <div className="flex items-center space-x-2">
              <div
                style={{
                  height: "28px",
                  width: "28px",
                  backgroundColor: cart.shopperData.color,
                  borderRadius: "50%",
                }}
              ></div>
              <h2 className="text-white text-xl font-bold border-b border-white/20 pb-1 flex items-center">
                User - {cart.shopperId}
              </h2>
            </div>

            {/* Grid container for products */}

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {cart.products.map((item, idx) => (
                <div
                  key={idx}
                  className="flex flex-col bg-white/10 rounded-lg p-3 backdrop-blur-sm"
                >
                  {/* Image & Product Name Container - Centered */}
                  <div className="flex flex-col items-center">
                    {/* Image Wrapper with Conditional Check Icon */}
                    <div className="relative w-20 h-20">
                      {/* Show Checkmark Only If Status is PAID */}
                      {item.status === "PAID" && (
                        <div className="absolute top-1 right-1 bg-green-500 text-white p-1 rounded-full shadow-md">
                          <Check size={16} />
                        </div>
                      )}

                      <img
                        src={item.productUrl || "/placeholder.svg"}
                        alt={item.name}
                        className="w-full h-full object-cover rounded-md"
                      />
                    </div>

                    {/* Product Name - Centered Below Image */}
                    <div className="text-white text-lg font-bold text-center mt-2 truncate w-full">
                      {item.productName}
                    </div>
                  </div>

                  {/* Quantity Info - Centered */}
                  <div className="text-white font-medium text-lg mt-2 text-center">
                    Quantity: {item.productCount}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
    </div>
  );
};

export default TempCart;
